<template>
  <div
    :class="slide.theme + (isHScreen ? ' h-screen' : ' h-default')"
    class="slide"
  >
    <video v-if="slide.video" class="slide__bg" loop muted autoplay>
      <source :src="slide.video.vimeo_raw" type="video/mp4" />
    </video>
    <component
      :is="'a_imageSource' | dashify"
      v-if="slide.background"
      :blok="setImageFormatting(slide, isHScreen)"
      :image-url="slide.background"
      :alt="slide.title"
      modifier-class="slide__bg"
    />
    <div class="container slide__content">
      <div class="row">
        <div :class="slideGrid" class="slide__content-left">
          <transition name="slide-up-1">
            <small
              v-show="visible"
              v-if="slide.pre_text"
              class="slide__pretext"
              >{{ slide.pre_text }}</small
            >
          </transition>
          <transition name="slide-up-1">
            <h2 v-show="visible" class="slide__title">
              {{ slide.title }}
            </h2>
          </transition>
          <transition name="slide-up-2">
            <div v-show="visible" v-if="slide.body_left">
              <component
                :is="item.component | dashify"
                v-for="item in slide.body_left"
                :key="item._uid"
                :blok="item"
                :modifier-class="getCompClass(item.component)"
              />
            </div>
          </transition>
        </div>
        <div class="col-12 col-md-6 slide__content-right">
          <div
            v-if="slide.body_right && slide.body_right.length"
            class="slide__content-image-left"
          >
            <component
              :is="'a_imageSource' | dashify"
              :blok="slide.body_right[0]"
              :image-url="slide.body_right[0].image"
              :alt="slide.body_right[0].title"
            />
          </div>
          <div
            v-if="slide.body_right && slide.body_right.length === 2"
            class="slide__content-image-right"
          >
            <component
              :is="'a_imageSource' | dashify"
              :blok="slide.body_right[0]"
              :image-url="slide.body_right[1].image"
              :alt="slide.body_right[1].title"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  props: {
    slide: {
      type: Object,
      default: () => {},
    },
    slideGrid: {
      type: String,
      default: 'col-12 col-md-6',
    },
    isHScreen: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    getCompClass(compName) {
      if (compName === 'a_link') {
        return 'icon icon--arrow slide__link'
      }
      return ''
    },
    setImageFormatting(slide, isHScreen) {
      return {
        image: slide.background,
        isHScreen,
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.slide-up-1-enter-active,
.slide-up-1-leave-active {
  transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
  opacity: 1;
}

.slide-up-2-enter-active,
.slide-up-2-leave-active {
  transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.15s;
  opacity: 1;
}

.slide-up-1-enter,
.slide-up-1-leave-active,
.slide-up-2-enter,
.slide-up-2-leave-active {
  display: inline-block;
  opacity: 0;
  transform: translate(0, 30px);
}

.slide {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.slide__dark {
  .slide__content {
    color: $white;

    .slide__link {
      color: $white;

      &:hover {
        color: $oslo-gray;
      }
    }
  }
}

.slide__light {
  .slide__content {
    .slide__link {
      color: $oslo-gray;

      &:hover {
        color: $tribal-black;
      }
    }
  }
}

.slide__bg {
  position: absolute;
  z-index: -1;
  min-width: 100%;
  min-height: 100%;
  display: block;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}

.slide__content {
  position: relative;
  z-index: 1;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(100vh - 68px);
  display: flex;

  .row {
    flex: 1 0 100%;
  }

  .slide__content-left {
    display: flex;
    flex-direction: column;

    p {
      @include font-size(18, rem-v(24));

      margin-top: 55px;
    }
  }

  .slide__content-image-left,
  .slide__content-image-right {
    width: 100%;
    margin-top: spacer(2);
    img {
      box-shadow: 0 25px 50px -20px rgba(0, 0, 0, 0.4);
      width: 100%;
    }
  }

  .slide__content-image-right {
    margin-left: spacer(1);
    display: none;
  }

  .slide__pretext {
    @include font-size(16);

    margin-bottom: 14px;
  }

  .slide__title {
    @include font-family($font-family-headings-bold, $headings-font-weight);
    @include font-size(36, rem-v(54));

    margin: 0 0 -38px;
  }

  .slide__link {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0;
    margin-top: 38px;
    text-align: center;
    align-self: flex-start;

    &::before {
      font-size: 10px;
      margin-right: 10px;
    }
  }
}

@include media-breakpoint-up(md) {
  .slide__content {
    .slide__content-image-left,
    .slide__content-image-right {
      margin-top: 0;
      width: 50%;
    }

    .slide__content-right {
      display: flex;
      flex-direction: row;
    }

    .slide__content-image-right {
      display: block;
      padding-top: 50%;
    }
  }
}
</style>
